import FileDropZone from './FileDropZone';

export default FileDropZone;
export * from './types';

export { FileDropZone };
